import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getChangecardList, bairunChangecardCheck } from '@/api/bairun/orderManage'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';

var _this;

export default {
  name: 'CardExamine',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      auditType: '1',
      // 1=待审核 2=已审核
      stationOptions: [],
      auditDialogVisible: false,
      selectRow: {},
      formData: {
        auditRemark: '',
        auditStatus: '',
        mainOrderNo: ''
      },
      dateRangeValueArr: [],
      auditingTable: {
        total: 0,
        tableData: [],
        searchInfo: {
          page: 1,
          pageSize: 10,
          type: '1',
          // 1=待审核 2=已审核
          stationId: ''
        }
      },
      auditedTable: {
        total: 0,
        tableData: [],
        searchInfo: {
          page: 1,
          pageSize: 10,
          type: '2',
          // 1=待审核 2=已审核
          stationId: ''
        }
      },
      rules: {
        auditStatus: [{
          required: true,
          message: '请选择审批结果',
          trigger: 'blur'
        }],
        auditRemark: [{
          required: true,
          message: '请输入审批意见',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;

                _this3.onTabClick();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 待审核
    onAuditingSubmit: function onAuditingSubmit() {
      this.auditingTable.searchInfo.page = 1;
      this.auditingTable.searchInfo.pageSize = 10;
      this.getAudtingTable();
    },
    onAuditingReset: function onAuditingReset() {
      this.auditingTable.searchInfo = {
        type: '1',
        page: 1,
        pageSize: 10,
        stationId: '',
        oldSvcNumber: '',
        newSvcNumber: ''
      };
      this.onAuditingSubmit();
    },
    handleAuditingSizeChange: function handleAuditingSizeChange(val) {
      this.auditingTable.searchInfo.pageSize = val;
      this.getAudtingTable();
    },
    handleAuditingCurrentChange: function handleAuditingCurrentChange(val) {
      this.auditingTable.searchInfo.page = val;
      this.getAudtingTable();
    },
    getAudtingTable: function getAudtingTable() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4; // eslint-disable-next-line eqeqeq

                if (that.auditingTable.searchInfo.stationId != '') {
                  that.auditingTable.searchInfo.stationId = parseInt(that.auditingTable.searchInfo.stationId);
                }

                _context4.next = 4;
                return getChangecardList(that.filterMap(that.auditingTable.searchInfo));

              case 4:
                res = _context4.sent;
                that.auditingTable.tableData = res.data.list;
                that.auditingTable.total = res.data.total;

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 已审核
    onAuditedSubmit: function onAuditedSubmit() {
      this.auditedTable.searchInfo.page = 1;
      this.auditedTable.searchInfo.pageSize = 10;
      this.getAudtedTable();
    },
    onAuditedReset: function onAuditedReset() {
      this.dateRangeValueArr = [];
      this.auditedTable.searchInfo = {
        type: '2',
        page: 1,
        pageSize: 10,
        stationId: '',
        oldSvcNumber: '',
        newSvcNumber: ''
      };
      this.onAuditedSubmit();
    },
    handleAuditedSizeChange: function handleAuditedSizeChange(val) {
      this.auditedTable.searchInfo.pageSize = val;
      this.getAudtedTable();
    },
    handleAuditedCurrentChange: function handleAuditedCurrentChange(val) {
      this.auditedTable.searchInfo.page = val;
      this.getAudtedTable();
    },
    getAudtedTable: function getAudtedTable() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5; // eslint-disable-next-line eqeqeq

                if (that.dateRangeValueArr.length == 2) {
                  console.log(that.dateRangeValueArr);
                  that.auditedTable.searchInfo.timeStart = that.dateRangeValueArr[0] + ' 00:00:00';
                  that.auditedTable.searchInfo.timeEnd = that.dateRangeValueArr[1] + ' 23:59:59';
                }

                debugger; // eslint-disable-next-line eqeqeq

                if (that.auditedTable.searchInfo.stationId != '') {
                  that.auditedTable.searchInfo.stationId = parseInt(that.auditedTable.searchInfo.stationId);
                }

                _context5.next = 6;
                return getChangecardList(that.filterMap(that.auditedTable.searchInfo));

              case 6:
                res = _context5.sent;
                that.auditedTable.tableData = res.data.list;
                that.auditedTable.total = res.data.total;

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // tab切换事件
    onTabClick: function onTabClick() {
      var that = this; // eslint-disable-next-line eqeqeq

      if (that.auditType == '1') {
        that.getAudtingTable();
      } // eslint-disable-next-line eqeqeq


      if (that.auditType == '2') {
        that.getAudtedTable();
      }
    },
    // 审批
    onAudit: function onAudit(row) {
      var that = this;
      that.auditDialogVisible = true;
      that.selectRow = row;
    },
    closeDialog: function closeDialog() {
      this.auditDialogVisible = false;
      this.selectRow = {};
      this.formData = {
        auditRemark: '',
        auditStatus: '',
        mainOrderNo: ''
      };
      this.onTabClick();
    },
    enterDialog: function enterDialog() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6;
                that.$refs['formData'].validate(function (valid) {
                  // eslint-disable-next-line no-empty
                  if (valid) {
                    that.formData.ID = that.selectRow.ID;
                    that.formData.stationId = that.selectRow.stationId;
                    that.formData.auditStatus = parseInt(that.formData.auditStatus);
                    bairunChangecardCheck(that.formData).then(function (res) {
                      // eslint-disable-next-line eqeqeq
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.closeDialog();
                      } // eslint-disable-next-line handle-callback-err

                    }, function (err) {});
                  } else {
                    return false;
                  }
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 过滤map中为空的key
    filterMap: function filterMap(map) {
      var resMap = {};

      for (var key in map) {
        // eslint-disable-next-line eqeqeq
        if (map[key] != '') {
          resMap[key] = map[key];
        }
      }

      return resMap;
    }
  }
};